<template>
  <div>
    <b-table
      :checked-rows.sync="$store.state.userManagement.checkedRows"
      :checkable="checkable"
      :loading="isLoading"
      :narrowed="true"
      :mobile-cards="true"
      :paginated="paginated"
      :per-page="perPage"
      :striped="false"
      :hoverable="true"
      default-sort="name"
      :data="users"
    >
      <b-table-column v-slot="props">
        <span>
          <a @click="$nav.viewUserGo(props.row.id)">
            <b-icon icon="file-find" size="is-small"></b-icon
          ></a>
        </span>
      </b-table-column>

      <b-table-column
        label="Name"
        field="name"
        sortable
        searchable
        v-slot="props"
      >
      <a @click="$nav.viewUserGo(props.row.id)" class="has-text-black-bis">
        {{ props.row.name }}
          </a>  
      </b-table-column>

      <b-table-column
        label="Email"
        field="email"
        searchable
        sortable
        v-slot="props"
      >
        {{ props.row.email }}
      </b-table-column>

      <b-table-column
        label="Travel Manager"
        field="travelArrangers.name"
        searchable
        sortable
        v-slot="props"
      >
        {{ props.row.travelArrangers ? props.row.travelArrangers.name : "" }}
      </b-table-column>

      <b-table-column
        label="Rule Group"
        field="tripCircultPolicyName"
        searchable
        sortable
        v-slot="props"
      >
        {{
          props.row.tripCircultPolicyName != null
            ? props.row.tripCircultPolicyName
            : ""
        }}
      </b-table-column>

      <section slot="empty" class="section">
        <div class="content has-text-grey has-text-centered">
          <template v-if="isLoading">
            <p>
              <b-icon icon="dots-horizontal" size="is-large"></b-icon>
            </p>
            <p>Fetching data...</p>
          </template>
          <template v-else>
            <p>
              <b-icon icon="emoticon-sad" size="is-large"></b-icon>
            </p>
            <p>No users found</p>
          </template>
        </div>
      </section>
    </b-table>
  </div>
</template>

<script>
export default {
  name: "UsersTable",
  props: {
    checkable: {
      type: Boolean,
      default: true,
    },
    checkedRows: {
      type: Array,
    },
    users: {
      type: Array,
    },
  },
  data() {
    return {
      checkedRows1: [],

      isModalActive: false,
      trashObject: null,

      isLoading: false,
      paginated: true,
      perPage: 20,
    };
  },
  computed: {
    selectedAttendees() {
      const result = this.checkedRows.map((item) => item.Id);

      console.log(result);
      return result;
    }
  },
  mounted() {},
  methods: {
    
  },
};
</script>
